const OutsourcingData = [{
        id: "9o",
        thumbnailFit: "cover",
        category: "모바일 앱",
        title: "엣지웍스 스마트팜 앱",
        body: "MQTT를 통한 IoT 센서 측정 데이터를 실시간 및 직접 연동하여 스마트팜 내부를 모니터링하고, 모터 및 펌프 등의 전원을 앱으로 제어하는 서비스입니다.",
        stack: "- MQTT, nodejs, flutter, fcm(Firebase Cloud Message)",
        hashtag: ["#App", "#Android", "#Flutter", "#nodejs", "#fcm", "#백엔드", "#프론트엔드", "#서비스", ],
        img: "./images/3_outsourcing/09_03.gif",
        logo: "./images/3_outsourcing/edgeworks-smartfarm.png",
        alt: "스마트팜"
    },
    {
        id: "8o",
        category: "업무 시스템·서비스 연동",
        title: "세븐파트너스 입찰 웹",
        body: `
        세븐파트너스 자사 직원들이 현재 엑셀로 번거롭게 보던 업무를 사이트 내에서 보다 쉽게 정리하고, 정확한 데이터 확인을 통하여 업무의 정확도를 높이기 위한 서비스입니다.
        \n\n
        여러 사이트에 포진한 데이터(입찰공고)를 크롤링을 통해 취합하여 한 개의 사이트에서 데이터를 확인하고 종류에 따라 분류하였습니다.
        `,
        stack: "- nodejs, ejs, python/crawling",
        hashtag: ["#Web", "#nodejs", "#ejs", "#python", "#웹크롤링", "#백엔드", "#프론트엔드", "#서비스", ],
        img: "./images/3_outsourcing/08_01.png",
        logo: "./images/3_outsourcing/08_02.png",
        alt: "세븐파트너스"
    },
    {
        id: "7o",
        category: "업무 시스템·서비스 연동",
        title: "kkday 카톡 연동",
        body: `
        KKday의 카카오톡 채널 REST API와 카카오 비즈 메시지 API로 연동한 서비스입니다. 
        \n\n
        카카오톡 채널 REST API는 고객 관리를 수월하게 해주며,
        카카오 비즈 메시지 API는 카카오 비즈니스 메시지 공식 딜러사 스윗트래커 비즈엠을 통해서 상품 주문한 정보를 고객에게 알림톡으로 발송합니다.
        `,
        stack: "- php Laravel",
        hashtag: ["#Web", "#php", "#larave", "#API", "#package"],
        img: "./images/3_outsourcing/07_01.png",
        logo: "./images/3_outsourcing/07_01.png",
        alt: "KKday"
    },
    {
        id: "6o",
        category: "업무 시스템·서비스 연동",
        title: "베오 챗봇 선물 추천시스템",
        body: "베오 챗봇 선물 추천 시스템은 고객의 취향과 상황을 고려하여 효율적이고 체계적으로 '선물하기'를 추천하기 위한 시스템 입니다.",
        stack: "-Javascript, nodejs, mysql, AWS EC2(ubuntu)",
        hashtag: ["#Web", "#Javascript", "#nodejs", "#mySQL", "#AWS", "#데이터분석", "#인공지능", "#서비스", ],
        img: "./images/3_outsourcing/06_04.gif",
        logo: "./images/3_outsourcing/06_06.jpeg",
        alt: "Beo"
    },
    {
        id: "5o",
        category: "모바일 앱",
        title: "아트릭스 Pinksalt",
        body: `
        Pinksalt는 사용자 휴대폰에 저장된 생체 인증을 통해 간편 로그인이 가능하고, 
        스마트 기기 연동으로 여성 건강 활동 및 관리에 보다 더 호율적으로 활용할 수 있으며,
        앱의 공지사항 및 안내사항을 푸시 알림으로 받을 수 있습니다.
        `,
        stack: "- flutter, weibview, fcm(Firebase Cloud Message)",
        hashtag: ["#App", "#Flutter", "#Android", "#iOS", "#fcm", "#프론트엔드", "#서비스", ],
        img: "./images/3_outsourcing/05_03.gif",
        logo: "./images/3_outsourcing/05_04.png",
        alt: "아트릭스"
    },
    {
        id: "4o",
        category: "플랫폼·웹 서비스",
        title: "브링커피 반응형 웹페이지",
        body: "자동견적결제 시스템으로써 반응형 웹페이지를 개발하였습니다. 제휴 맺은 업체의 주문내역을 자동 수집하여, 관리자 페이지에서 배달 당일 후불로 결제할 수 있도록 설계했습니다.",
        stack: "- php, mysql",
        hashtag: ["#Web", "#php", "#백엔드", "#프론트엔드", "#서비스", ],
        img: "./images/3_outsourcing/04_03.gif",
        logo: "./images/3_outsourcing/04_04.png",
        alt: "브링커피"
    },
    {
        id: "3o",
        category: "모바일 앱",
        title: "아비도스 스팸 신고 앱",
        body: "기존에 있는 앱에서 핸드폰에 수신된 MMS 메세지 선택하여 문자 스팸 등의 내용 및 이미지를 신고하는 기능을 추가 개발하였습니다.",
        stack: "- react-native",
        hashtag: ["#App", "#React-native", "#프론트엔드", "#서비스", ],
        img: "./images/3_outsourcing/03_03.gif",
        logo: "./images/3_outsourcing/03_04.png",
        alt: "아비도스"
    },
    {
        id: "2o",
        category: "플랫폼·웹 서비스",
        title: "Pooluck Warp",
        body: `
        동네 및 위치를 기반으로 하는 무료 카풀 매칭 서비스 입니다.
        출퇴근시간(아침 7시~9시, 저녁 6시~8시) 유료카풀과
        출퇴근시간 외 무료 카풀이 모두 가능한 카풀 매칭 어플리케이션입니다.
        `,
        stack: "- react-native, php, mysql",
        hashtag: ["#App", "#React", "#React-native", "#php", "#mySQL", "#백엔드", "#프론트엔드", "#서비스", ],
        img: "./images/3_outsourcing/02_03.gif",
        logo: "./images/3_outsourcing/02_04.png",
        alt: "풀럭"
    },
    {
        id: "1o",
        category: "업무 시스템·서비스 연동",
        title: "대우건설 펀치리스트",
        body: `
        대형 건설사인 대우건설에서 진행한 프로젝트로 건설현장에서 발생하는 하자와 관련한 시스템을 구축하였습니다.
        \n\n
        각 사용자를 정의하고, 대시보드에서 이슈 및 진행 상황을 체크할 수 있으며, 앱으로 현장에서 효율적이고 편리한 일처리가 가능하도록 개발했습니다.
        `,
        stack: "- react, flutter, nodejs, mysql",
        hashtag: ["#App", "#Web", "#React", "#Flutter", "#nodejs", "#mySQL", "#백엔드", "#프론트엔드", "#서비스", ],
        img: "./images/3_outsourcing/01_04.gif",
        logo: "./images/3_outsourcing/01_05.png",
        alt: "대우건설"
    },
]

export default OutsourcingData;